module.exports = __webpack_public_path__ + "static/media/java-logo.6cf2d330.png";